import {User} from "@sentry/browser";
import Icon from "@mdi/react";
import {mdiAccount, mdiChevronLeft} from "@mdi/js";
import {useContext, useEffect} from "preact/hooks";
import {ComponentChildren} from "preact";
import {GlobalDataContext} from "../app";
import {Dropdown} from "./generic/dropdown";
import {Button} from "./generic/button";
import {PopupMenu} from "./generic/menu";
import {HorizontalNav} from "./generic/nav";
import styled from "styled-components";

export type HeaderProps = {
    user: User | null | undefined;
    links?: ComponentChildren;
    title?: string;
    showBackButton?: boolean;
    titleMarkup?: (title: string) => ComponentChildren;
    className?: string
};

function LoginLink(props: {className?: string}) {
    const url = new URL("/login", location.href);
    url.searchParams.set("return", `${location.pathname}${location.search}`);

    return <Button as="a" href={url.toString()} className="btn">Login</Button>
}

export const Title = styled.h1`
    font-size: 1.2rem;
    margin: 0 0 0 .5rem;
    padding: .5rem;
    color: ${props => props.theme.colors.fg}
`;

export const Header = styled(function (props: HeaderProps) {
    const globals = useContext(GlobalDataContext);
    const appTitle = globals?.title ?? "Temperature";

    const titleMarkup = props.titleMarkup ?? ((title: string) => <Title>{title}</Title>);

    useEffect(() => {
        if (props.title) {
            document.title = `${props.title} - ${appTitle}`;
        } else {
            document.title = appTitle;
        }
    }, [props.title]);

    return <header className={props.className}>
        <div style={{display: "flex", alignItems: "center", paddingLeft: ".5rem"}}>
            {props.showBackButton ? <Button as="a" href="/" className="btn"><Icon path={mdiChevronLeft} size={1} /></Button> : null}
            {titleMarkup(props.title ?? appTitle)}
        </div>
        <HorizontalNav>
            {props.links}
            {props.user !== undefined
                ? <li style={{position: "relative"}}>{
                    props.user !== null
                        ? <Dropdown
                            content={<PopupMenu>
                                <li><a href="/admin">Administration</a></li>
                                <li><a href="/logout">Log out</a></li>
                            </PopupMenu>}
                            position={"bottom"}
                        >
                            <Icon path={mdiAccount} size="1.5em"/>
                            {props.user.name}
                        </Dropdown>
                        : <LoginLink />
                }</li>
                : null
            }
        </HorizontalNav>
    </header>
})`
    background: ${props => props.theme.colors.secondaryBg};
    color: ${props => props.theme.colors.secondaryFg};
    font-size: .8rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: .5rem .5rem .5rem 0;
    
    .btn {
        padding: 1rem;
    }
    
    .btn h1 {
        padding: 0;
    }
`;
